"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZrxApprovalNeeded = void 0;
const api_1 = require("../../../api");
const erc20Allowance_abi_1 = require("../utils/abi/erc20Allowance-abi");
const bignumber_1 = require("../utils/bignumber");
const constants_1 = require("../utils/constants");
const helpers_1 = require("../utils/helpers/helpers");
async function ZrxApprovalNeeded({ adapterManager, web3 }, { quote, wallet }) {
    var _a, _b;
    const { sellAsset } = quote;
    try {
        if (sellAsset.chainId !== 'eip155:1') {
            throw new api_1.SwapError('[ZrxApprovalNeeded] - sellAsset chainId is not supported', {
                code: api_1.SwapErrorTypes.UNSUPPORTED_CHAIN,
                details: { chainId: sellAsset.chainId }
            });
        }
        // No approval needed for trading eth itself
        if (sellAsset.assetId === 'eip155:1/slip44:60') {
            return { approvalNeeded: false };
        }
        const accountNumber = (0, bignumber_1.bnOrZero)(quote.sellAssetAccountId).toNumber();
        const adapter = await adapterManager.byChainId(sellAsset.chainId);
        const bip44Params = adapter.buildBIP44Params({ accountNumber });
        const receiveAddress = await adapter.getAddress({ wallet, bip44Params });
        if (!quote.sellAsset.tokenId || !quote.allowanceContract) {
            throw new api_1.SwapError('[ZrxApprovalNeeded] - tokenId and allowanceTarget are required', {
                code: api_1.SwapErrorTypes.VALIDATION_FAILED,
                details: { chainId: sellAsset.chainId }
            });
        }
        const allowanceResult = await (0, helpers_1.getERC20Allowance)({
            web3,
            erc20AllowanceAbi: erc20Allowance_abi_1.erc20AllowanceAbi,
            tokenId: quote.sellAsset.tokenId,
            spenderAddress: quote.allowanceContract,
            ownerAddress: receiveAddress
        });
        const allowanceOnChain = (0, bignumber_1.bnOrZero)(allowanceResult);
        if (!((_a = quote.feeData.chainSpecific) === null || _a === void 0 ? void 0 : _a.gasPrice))
            throw new api_1.SwapError('[ZrxApprovalNeeded] - no gas price with quote', {
                code: api_1.SwapErrorTypes.RESPONSE_ERROR,
                details: { feeData: quote.feeData }
            });
        return {
            approvalNeeded: allowanceOnChain.lte((0, bignumber_1.bnOrZero)(quote.sellAmount)),
            gas: constants_1.APPROVAL_GAS_LIMIT,
            gasPrice: (_b = quote.feeData.chainSpecific) === null || _b === void 0 ? void 0 : _b.gasPrice
        };
    }
    catch (e) {
        if (e instanceof api_1.SwapError)
            throw e;
        throw new api_1.SwapError('[ZrxApprovalNeeded]', {
            cause: e,
            code: api_1.SwapErrorTypes.CHECK_APPROVAL_FAILED
        });
    }
}
exports.ZrxApprovalNeeded = ZrxApprovalNeeded;
